module.exports = __webpack_public_path__ + "img/ELM327.3fdc82d0.jpg";